const doc = [({"ja":({"adminConstantBankDepositType":({"ordinaryDeposit":"普通預金", "checkingAccount":"当座預金"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;